import React, { useState } from "react";
import { Box, IconButton, Button, Grow } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import CloseIcon from "@mui/icons-material/Close";
import ModeCommentOutlinedIcon from "@mui/icons-material/ModeCommentOutlined";

const Help = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleOpenMenu = () => {
    setIsMenuOpen(true);
  };

  const handleCloseMenu = () => {
    setIsMenuOpen(false);
  };

  const handleEmail = () => {
    window.location.href = `mailto:${process.env.REACT_APP_SOPORTE_EMAIL}`;
    handleCloseMenu();
  };

  return (
    <Box sx={{ width: '100%', height: isMenuOpen ? 128 : 50, position: 'relative', overflow: 'hidden', transition: 'height 250ms ease' }}>
      <Grow in={!isMenuOpen} timeout={800}>
        <Box sx={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Button
            sx={{
              height: '50px',
              width: '120px',
              color: 'white',
              padding: '20px 15px',
              fontSize: '14px',
              fontWeight: '600',
              borderRadius: '50px',
              cursor: 'pointer',
              outline: 'none',
              textTransform: 'none',
              backgroundColor: '#23577E',
              '&:hover': {
                backgroundColor: '#23577E',
              },
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
            }}
            onClick={handleOpenMenu}
          >
            <ModeCommentOutlinedIcon sx={{ fontSize: '14px' }} />
            <span style={{ textTransform: 'capitalize' }}>soporte</span>
          </Button>
        </Box>
      </Grow>

      <Grow in={isMenuOpen} timeout={800}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', position: 'absolute', inset: 0, justifyContent: 'center', gap: '12px' }}>
          <Box sx={{ display: 'flex', flexDirection: 'row', gap: '28px' }}>
            <IconButton
              aria-label="Contactar a soporte por correo electrónico"
              sx={{
                height: '50px',
                width: '50px',
                color: '#ffffff',
                backgroundColor: '#23577E',
                '&:hover': {
                  backgroundColor: '#23577E',
                },
                boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.3)',
              }}
              onClick={handleEmail}
            >
              <EmailOutlinedIcon />
            </IconButton>
            <IconButton component="a" href={`${process.env.REACT_APP_SOPORTE_TELEFONO}`}
              target="_blank" rel="noopener noreferrer" aria-label="Contactar a soporte por WhatsApp"
              sx={{
                height: '50px',
                width: '50px',
                color: '#ffffff',
                backgroundColor: '#23577E',
                '&:hover': {
                  backgroundColor: '#23577E',
                },
                boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.3)',
              }}
            >
              <WhatsAppIcon />
            </IconButton>
          </Box>
          <IconButton aria-label="Cerrar opciones de soporte" onClick={handleCloseMenu}
            sx={{ width: '36px', height: '36px', borderRadius: '50%', backgroundColor: '#23577E', '&:hover': { backgroundColor: '#23577E' } }}>
            <CloseIcon sx={{ color: 'white', fontSize: '20px' }} />
          </IconButton>
        </Box>
      </Grow>
    </Box>
  );
};

export default Help;
